<template>
    <div class="doc-section">
        <h1>Dar de alta un usuario</h1>
        <p>Vista que permite registrar un usuario.</p>
        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <ul class="ul-contenedor step-list">
            <li>a) Nombre del usuario, identificador del usuario, valor con el que inicia sesión el usuario.</li>
            <li>b) Rol de usuario, rol asignado a usuario. </li>
            <li>c) Contraseña, valor con el que inicia sesión el usuario. La contraseña debe tener una longitud mínima de 12 caracteres y estar compuesta por 3 palabras separadas por un espacio...</li>
            <li>d) Confirmación de contraseña, valor que debe coincidir con la contraseña introducida anteriormente.</li>
            <li>e) Grupo al que pertenece el usuario.</li>
        </ul>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesFiltradas" />
        </div>

        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesFiltradas" />
        </div>
    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'AltaUsuario',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        // 🎯 Declaramos las imágenes una sola vez usando una bandera para identificar móviles
        imagenesBase: [
            {
                nombre: "Alta de usuario",
                urlWeb: "img/usuarios/altaUsuario.png",
                urlMovil: "img/usuarios/moviles/altaUsuario.png",
                descripcion: "Formulario para dar de alta un usuario"
            },
            {
                nombre: "Exito alta de usuario",
                urlWeb: "img/usuarios/exitoAltaUsuario.png",
                urlMovil: "img/usuarios/exitoAltaUsuario.png",
                descripcion: "Mensaje de exito de alta de usuario"
            }
        ]
    }),
    computed: {
        // 🎯 Esta función procesa el arreglo limpio en tiempo real evitando duplicar código escrito
        imagenesFiltradas() {
            return this.imagenesBase.map(img => ({
                nombre: img.nombre,
                descripcion: img.descripcion,
                url: this.plataforma === 'web' ? img.urlWeb : img.urlMovil
            }));
        }
    },
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>